import { Box, Container, Grid, Stack } from '@mui/material';
import OverviewStat from '../components/home/OverviewStat';
import { useQuery } from '@tanstack/react-query';
import { getPlatformStatistic } from '../api/statistic.api';
import { useVirtualBalanceContext } from '../context/VirtualBalanceContext';
import { useNotification } from '../hooks/useNotification';
import PlatformStatistic from '../components/home/PlatformStatistic';
import StartNowBlock from '../components/home/StartNowBlock';
import {
  getInferencesCount,
  useGetInferencesCount,
} from '../api/inference.api';
import { usePrivy } from '@privy-io/react-auth';
import LoginBanner from './login/LoginBanner';
import StakeSummary from './staker/components/StakeSummary';

const Home = () => {
  const { virtualBalance, xVirtualBalance } = useVirtualBalanceContext();
  useNotification(true);

  const { data: platformStatistic } = useQuery({
    queryKey: ['getPlatformStatistic'],
    queryFn: getPlatformStatistic,
  });

  const { ready, user, authenticated } = usePrivy();
  const { data: inferencesCount } = useGetInferencesCount();

  return (
    <Container maxWidth="lg">
      <Box my={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid item container spacing={3}>
              <OverviewStat
                xVirtualBalance={xVirtualBalance}
                virtualBalance={virtualBalance}
              ></OverviewStat>

              {!user && <LoginBanner title="Login to view staking info" />}
              {ready && !!user && (
                <Grid item xs={12}>
                  <StakeSummary />
                </Grid>
              )}

              {/* <StartNowBlock></StartNowBlock> */}
              {/* <PlatformStatistic
                dAppTotal={platformStatistic?.dappAccess || 0}
                validatorTotal={platformStatistic?.totalValidatorUser || 0}
                contributorTotal={
                  platformStatistic?.totalUniqueContributors || 0
                }
                revenue={platformStatistic?.totalEmissionAmount || 0}
                contributionTotal={
                  platformStatistic?.totalContributionMade || 0
                }
                inferencesCount={inferencesCount?.data.inference.total || 0}
              ></PlatformStatistic> */}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Home;
